import { LoginAuthType, yupLocalized } from "@ryde/shared";

export const yupLoginValidationSchema = {
  [LoginAuthType.Username]: yupLocalized.string().when("loginType", {
    is: LoginAuthType.Username,
    then: schema => schema.required(),
  }),
  [LoginAuthType.Email]: yupLocalized
    .string()
    .email()
    .when("loginType", {
      is: LoginAuthType.Email,
      then: schema => schema.required(),
    }),
  [LoginAuthType.Phone]: yupLocalized.string().when("loginType", {
    is: LoginAuthType.Phone,
    then: schema => schema.required(),
  }),
  password: yupLocalized.string().required(),
  loginType: yupLocalized
    .mixed<LoginAuthType.Username | LoginAuthType.Email | LoginAuthType.Phone>()
    .oneOf([LoginAuthType.Username, LoginAuthType.Email, LoginAuthType.Phone])
    .required(),
};
